module.exports = __webpack_public_path__ + "static/media/waystar_royco.87b00f18.jpg";